import _ from 'lodash'
import { colorList } from 'utils/colors'
import HelperCart from 'utils/helper-cart'
import EmployeeCard, { EmployeeCardModes } from 'components/molecules/EmployeeCard'
import { ThemedSizes } from 'styles/themed'
import React from 'react'
import HelperString from 'utils/helper-string'
import { useSelector } from 'react-redux'
import { selectCartEmployees } from 'services/redux/cart/reducers'
import { cartConstants } from 'services/redux/cart/constants'
import HelperAlerts from 'utils/HelperAlerts'
import i18n from 'utils/i18n'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'

const EmployeeInternal = ({ item, show, onPress }) => {
	
	const _cartBookingCoworkers = useSelector( selectCartEmployees )[ item?.guid ]; // KEEP THIS FOR THE RE-RENDER
	const _cartTimeslots = useSelector( state => {
		return state.cart[cartConstants.TIMESLOTS];
	} );
	
	let actionItem = null;
	let onPressEmployee = null;
	let onPressActionItem = null;
	
	const onEmployeePress = ( employee ) => {
		if( _.size( _cartTimeslots ) ){
			HelperAlerts.alert(
				i18n.t( 'page.create.coworker.alerts.changing_coworker' ),
				null,
				[
					{
						text: i18n.t( 'buttons.cancel' ),
					},
					{
						text: i18n.t( 'buttons.ok' ),
						onPress: () => {
							HelperCart.resetCartTimeslots();
							HelperCart.toggleEmployee( employee )
						}
					}
				]
			);
			return;
		}
		
		HelperCart.toggleEmployee( employee );
	}
	
	switch( true ) {
		case _.isFunction( onPress ):
			onPressEmployee = onPress.bind( this, item );
			break;
		
		case _.get( item, 'readOnly', false ):
			// no action button
			break;
		
		case _.get( item, 'deletable', false ):
			onPressActionItem = onEmployeePress.bind( this );
			actionItem = <Icon icon={ IconSystemConstants.TRASH } color={ colorList.RED.primary } />;
			break;
		
		default:
			onPressEmployee = onEmployeePress.bind( this );
			actionItem = (
				<Icon icon={ IconSystemConstants.CHECKBOX }
					checked={ HelperCart.isEmployeeSelected( item.guid ) }
					color={ colorList.ORANGE.primary }
				/>
			);
			break;
	}
	
	return (
		<EmployeeCard
			key={ HelperString.hash( `employee`, item ) }
			mode={ EmployeeCardModes.listItem }
			employee={ item }
			avatarSize={ ThemedSizes.S }
			onPress={ onPressEmployee }
			actionItem={ actionItem }
			actionItemOnPress={ onPressActionItem }
			show={ show }
			showHeart={ false }
		/>
	);
}

export default EmployeeInternal
